import { ISearchFilter } from "../../global/models/search-context";

export interface ISearchField {
    operator: SearchOperator,
    filter: ISearchFilter,
    query: string,
    valid?: boolean
}

export enum SearchOperator {
    And = 'AND',
    Or = 'OR',
    Not = 'NOT',
    Exactly = 'Exactly'
}